import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, Spin, Space } from 'antd';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { menus } from './menus';
import {
  SiderAntd,
  ContainerLogo,
  SubMenuCustom,
  SubItemMenuCustom,
} from './style';
import Logo from '../Logo';
import LogoVGR from '../LogoVGR';
import { useAuth } from '../../hooks/auth';
import { useCliente } from '../../hooks/cliente';
import { IconSair } from './iconsMenu';
import { ModalAttendance } from '../ModalAttendance';

function MenuLateral({ carregando }) {
  const history = useHistory();
  const { signOut, temPermissao } = useAuth();
  const { navegarMenu, updateNavegarMenu } = useCliente();
  const [fechado, setFechado] = useState(true);
  const [clicked, setClicked] = useState('');
  const [url, setUrl] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const pageURL = window.location.pathname;
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isPortalMobile = isMobile && pageURL === '/portal-de-informacoes';
  const parentMenu = menus.find(menu =>
    menu.menus?.some(submenu => submenu.url === pageURL)
  );
  const selectedSubmenu = parentMenu?.menus.find(
    submenu => submenu.url === pageURL
  );
  const selectedMenu = menus.find(menu => menu.url === pageURL);
  const defaultSelectedKey = selectedSubmenu?.id || `${selectedMenu?.key || 7}`;

  const validate =
    window.location.pathname === '/atendimento' ? 'true' : undefined;

  useEffect(() => {
    if (isMobile) {
      setFechado(true);
    }
  }, [isMobile, pageURL]);

  document.title = !validate && 'TMOV GR';

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const cancelModal = () => {
    toggleModal();
  };

  const handlerRedirect = item => {
    const location = item && history.location.pathnome !== item;
    return location && history.push(item);
  };

  const okModal = () => {
    toggleModal();
    updateNavegarMenu(true);
    handlerRedirect(url);
  };

  const handlerPath = item => {
    setClicked(item.id);
    setUrl(item.url);

    return !navegarMenu ? toggleModal() : handlerRedirect(item.url);
  };

  const subMenu = menu => (
    <SubMenuCustom
      id="subMenuItem"
      key={menu.id}
      selectedkeys={[menu.id]}
      title={!fechado && menu.nome}
      onClick={() => setClicked(menu.id)}
      icon={
        clicked === menu.id || parentMenu?.id === menu.id
          ? menu.icone2
          : menu.icone
      }
      style={{
        fontWeight:
          clicked === menu.id || parentMenu?.id === menu.id ? 'bold' : '',
      }}
    >
      {menu.menus.map(sub => {
        if (!sub.menus && sub.permissoes && !temPermissao(sub.permissoes)) {
          return null;
        }

        if (sub.menus && sub.menus.length > 0) {
          const subMenus = sub.menus.filter(subMenuFilter =>
            subMenuFilter.permissoes
              ? temPermissao(subMenuFilter.permissoes)
              : true
          );

          if (subMenus.length === 0) {
            return false;
          }

          return subMenu(sub);
        }
        return (
          <SubItemMenuCustom
            key={sub.id}
            title={menu.nome}
            selectedkeys={[menu.id]}
            onClick={() => handlerPath(sub)}
          >
            <span>{sub.nome}</span>
          </SubItemMenuCustom>
        );
      })}
    </SubMenuCustom>
  );
  const sairOnClick = async () => {
    if (!navegarMenu) {
      toggleModal();
      return;
    }

    await signOut();
  };
  return (
    <SiderAntd
      validate={validate}
      $isPortalMobile={isPortalMobile}
      collapsed={fechado}
      collapsedWidth={isPortalMobile ? 0 : 80}
      collapsible={isPortalMobile}
      onCollapse={setFechado}
      onMouseOver={() => !isPortalMobile && setFechado(false)}
      onMouseLeave={() => !isPortalMobile && setFechado(true)}
    >
      <ModalAttendance
        title="As informações serão perdidas, deseja sair?"
        visible={isModalVisible}
        cancelBtn={cancelModal}
        okBtn={okModal}
      />
      <ContainerLogo>
        {!fechado ? (
          <Logo
            size="lg"
            isCollapsed={fechado}
            logoWhite={true}
            linkTo="/painel-de-controle"
          />
        ) : (
          <LogoVGR
            isCollapsed={fechado}
            logoWhite={true}
            linkTo="/painel-de-controle"
          />
        )}
      </ContainerLogo>

      {!carregando ? (
        <Menu
          defaultSelectedKeys={[defaultSelectedKey]}
          defaultOpenKeys={parentMenu ? [parentMenu.id] : []}
          mode="inline"
          style={{
            background: ' #0D364A',
            color: '#fff',
          }}
        >
          {menus.map(menu => {
            if (
              !menu.menus &&
              menu.permissoes &&
              !temPermissao(menu.permissoes)
            ) {
              return;
            }

            if (menu.menus && menu.menus.length > 0) {
              const subMenus = menu.menus.filter(subMenuFilter =>
                subMenuFilter.permissoes
                  ? temPermissao(subMenuFilter.permissoes)
                  : true
              );

              if (subMenus.length === 0) {
                return false;
              }

              return subMenu(menu);
            }

            return (
              <Menu.Item
                title={menu.nome}
                key={menu.key}
                selectedkeys={[menu.id]}
                icon={menu.url === pageURL ? menu.icone2 : menu.icone}
                onClick={() => handlerPath(menu)}
              >
                {!fechado && (
                  <span className="spanMenu" style={{ marginLeft: '15px' }}>
                    {menu.nome}
                  </span>
                )}
              </Menu.Item>
            );
          })}
          <Menu.Item
            id="sair"
            key="sair"
            style={{
              width: '100%',
            }}
            icon={
              <IconSair
                style={{
                  color: '#707070',
                  cursor: 'pointer',
                }}
                onClick={sairOnClick}
              />
            }
          >
            {!fechado && (
              <button
                type="button"
                id="sairTexto"
                onClick={sairOnClick}
                style={{
                  padding: 0,
                  border: 0,
                  background: 'transparent',
                  marginLeft: '15px',
                }}
              >
                Sair
              </button>
            )}
          </Menu.Item>
        </Menu>
      ) : (
        <Space
          size="middle"
          style={{
            width: '100%',
            justifyContent: 'center',
            marginTop: '20px',
          }}
        >
          <Spin
            size={fechado ? 'default' : 'large'}
            className="ant-spin-white"
          />
        </Space>
      )}
    </SiderAntd>
  );
}

MenuLateral.propTypes = {
  carregando: PropTypes.bool,
};

MenuLateral.defaultProps = {
  carregando: null,
};

export default MenuLateral;
